import handlebars from "handlebars";
import prioritiesTemplate from "../templates/prioritiesTemplate";

export const compilePrioritiesTemplate = (prioritiesData: any): string => {
    const compilePrioritiesTemplate = handlebars.compile(prioritiesTemplate);
    
    const templateData = {
        assetManagement: prioritiesData?.assetManagement || "",
        leasing: prioritiesData?.leasing || "",
        building: prioritiesData?.building || "",
        sustainability: prioritiesData?.sustainability || "",
        social: prioritiesData?.social || "",
        other: prioritiesData?.other || "",
        breaksExpiries: prioritiesData?.breaksExpiries || "",
        regears: prioritiesData?.regears || ""
    };
    
    return compilePrioritiesTemplate(templateData);
};